import Navbar from "@/components/sections/Navbar";
import HeroSection from "@/components/sections/HeroSection";
import ProblemSection from "@/components/sections/ProblemSection";
import SolutionSection from "@/components/sections/SolutionSection";
import HowItWorksSection from "@/components/sections/HowItWorksSection";
import InteractiveDemoSection from "@/components/sections/InteractiveDemoSection";
import FeaturesSection from "@/components/sections/FeaturesSection";
import UseCasesSection from "@/components/sections/UseCasesSection";
import PerformanceFeedbackSection from "@/components/sections/PerformanceFeedbackSection";
import CTASection from "@/components/sections/CTASection";
import Footer from "@/components/sections/Footer";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen">
      <Navbar />
      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <HowItWorksSection />
      <InteractiveDemoSection />
      <FeaturesSection />
      <UseCasesSection />
      <PerformanceFeedbackSection />
      <CTASection />
      <Footer />
    </div>
  );
}
